module.exports = __webpack_public_path__ + "media/images/fpp-banner-1-ee77381fc3039d008c8d17b9d2069218.png";